var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-all-customer',{staticClass:"pt-all-customer__page"})}
var staticRenderFns = []

export { render, staticRenderFns }